export default __webpack_public_path__ + "locales/lo-LA/DeleteThirdPartyDialog.json?hash=3d49e48cfd152dc96e062e6d7421cf90";